import React, { useState } from "react";
import { Grid, Card, Typography, Box, Modal, IconButton } from "@mui/material";
import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import Container from "react-bootstrap/Container";
import { ArrowBackIos, ArrowForwardIos, Close } from "@mui/icons-material";
import "./Office.css";

const itemData = [
  {
    img: "/Images/Office/office-three-chaises.png",
    title:
      "Espace thérapie, Nawel Bouchoukh, psychologue clinicienne, ile de France",
    rows: 2,
    cols: 2,
  },
  {
    img: "/Images/Office/office-my-pannel.png",
    title:
      "Plaque professionnelle, Nawel Bouchoukh, psychologue clinicienne, ile de France",
  },
  {
    img: "/Images/Office/office-ext.png",
    title:
      "Extérieur du cabinet, Nawel Bouchoukh, psychologue clinicienne, ile de France",
  },
  {
    img: "/Images/Office/office-pannels.png",
    title:
      "Signalétique du cabinet, Nawel Bouchoukh, psychologue clinicienne, ile de France",
    cols: 2,
  },
  {
    img: "/Images/Office/office-bureau.png",
    title:
      "Bureau de consultation, Nawel Bouchoukh, psychologue clinicienne, ile de France",
    cols: 2,
  },
  {
    img: "/Images/Office/office-salon.png",
    title:
      "Salon d'accueil, Nawel Bouchoukh, psychologue clinicienne, ile de France",
    rows: 2,
    cols: 2,
  },
  {
    img: "/Images/Office/office-bougie.png",
    title:
      "Ambiance du cabinet, Nawel Bouchoukh, psychologue clinicienne, ile de France",
  },
  {
    img: "/Images/Office/office-half-salon.png",
    title:
      "Espace détente, Nawel Bouchoukh, psychologue clinicienne, ile de France",
  },
  {
    img: "/Images/Office/office-dor.png",
    title:
      "Décoration du cabinet, Nawel Bouchoukh, psychologue clinicienne, ile de France",
    rows: 2,
    cols: 4,
  },
];

const LocationSection = () => {
  const [selectedImageIndex, setSelectedImageIndex] = useState<number | null>(
    null
  );

  const handleImageClick = (index: number) => {
    setSelectedImageIndex(index);
  };

  const handleCloseModal = () => {
    setSelectedImageIndex(null);
  };

  const handlePrevImage = () => {
    if (selectedImageIndex !== null) {
      setSelectedImageIndex(
        selectedImageIndex === 0 ? itemData.length - 1 : selectedImageIndex - 1
      );
    }
  };

  const handleNextImage = () => {
    if (selectedImageIndex !== null) {
      setSelectedImageIndex(
        selectedImageIndex === itemData.length - 1 ? 0 : selectedImageIndex + 1
      );
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === "ArrowLeft") {
      handlePrevImage();
    } else if (event.key === "ArrowRight") {
      handleNextImage();
    } else if (event.key === "Escape") {
      handleCloseModal();
    }
  };

  return (
    <section id="office" className="office-section">
      <Container>
        <Box sx={{ textAlign: "center", mb: 7 }}>
          <span className="luxe-eyebrow">Le cabinet</span>
          <Typography
            variant="h3"
            className="luxe-heading"
            sx={{ fontWeight: 700, mb: 2, letterSpacing: "-0.02em" }}
          >
            Notre Localisation
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "var(--luxe-muted)",
              maxWidth: "600px",
              margin: "0 auto",
              fontSize: "1.1rem",
              lineHeight: 1.7,
              fontWeight: 300,
            }}
          >
            Découvrez mon cabinet et trouvez facilement votre chemin.
          </Typography>
        </Box>
        <Grid container spacing={4} alignItems="center">
          {/* Section Photos */}
          <Grid item xs={12} md={6}>
            <ImageList
              sx={{
                width: "100%",
                height: 460,
                overflow: "auto",
              }}
              variant="quilted"
              cols={4}
              rowHeight={115}
            >
              {itemData.map((item, index) => (
                <ImageListItem
                  key={item.img}
                  cols={item.cols || 1}
                  rows={item.rows || 1}
                  sx={{ cursor: "pointer" }}
                  onClick={() => handleImageClick(index)}
                >
                  <img
                    src={item.img}
                    alt={item.title}
                    loading={index < 4 ? "eager" : "lazy"}
                    decoding="async"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transition: "transform 0.3s ease",
                      backgroundColor: "#f0f0f0",
                    }}
                    onLoad={(e) => {
                      e.currentTarget.style.backgroundColor = "transparent";
                    }}
                  />
                </ImageListItem>
              ))}
            </ImageList>
          </Grid>

          {/* Section Carte */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                height: "100%",
                borderRadius: "16px",
                overflow: "hidden",
                border: "1px solid rgba(201, 169, 106, 0.4)",
                boxShadow: "0 18px 45px rgba(26, 23, 18, 0.15)",
              }}
            >
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2627.555025919116!2d2.433591976453657!3d48.80947067132552!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e673505c4bafd5%3A0x5e7117c522553eb1!2sNawel%20BOUCHOUKH!5e0!3m2!1sfr!2sfr!4v1765359809950!5m2!1sfr!2sfr"
                width="100%"
                height="460px"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Maps"
              ></iframe>
            </Card>
          </Grid>
        </Grid>

        {/* Modal Lightbox */}
        <Modal
          open={selectedImageIndex !== null}
          onClose={handleCloseModal}
          onKeyDown={handleKeyPress}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              position: "relative",
              maxWidth: "70vw",
              maxHeight: "70vh",
              outline: "none",
            }}
          >
            {selectedImageIndex !== null && (
              <>
                {/* Bouton Fermer */}
                <IconButton
                  onClick={handleCloseModal}
                  sx={{
                    position: "absolute",
                    top: -40,
                    right: -10,
                    color: "white",
                    backgroundColor: "rgba(0,0,0,0.6)",
                    "&:hover": { backgroundColor: "rgba(0,0,0,0.8)" },
                    zIndex: 1001,
                    width: 40,
                    height: 40,
                  }}
                >
                  <Close />
                </IconButton>

                {/* Bouton Précédent */}
                <IconButton
                  onClick={handlePrevImage}
                  sx={{
                    position: "absolute",
                    left: -50,
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "white",
                    backgroundColor: "rgba(0,0,0,0.6)",
                    "&:hover": { backgroundColor: "rgba(0,0,0,0.8)" },
                    zIndex: 1001,
                    width: 40,
                    height: 40,
                  }}
                >
                  <ArrowBackIos />
                </IconButton>

                {/* Bouton Suivant */}
                <IconButton
                  onClick={handleNextImage}
                  sx={{
                    position: "absolute",
                    right: -50,
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "white",
                    backgroundColor: "rgba(0,0,0,0.6)",
                    "&:hover": { backgroundColor: "rgba(0,0,0,0.8)" },
                    zIndex: 1001,
                    width: 40,
                    height: 40,
                  }}
                >
                  <ArrowForwardIos />
                </IconButton>

                {/* Image */}
                <img
                  src={itemData[selectedImageIndex].img}
                  alt={itemData[selectedImageIndex].title}
                  style={{
                    width: "100%",
                    height: "auto",
                    maxHeight: "70vh",
                    objectFit: "contain",
                    borderRadius: "12px",
                    boxShadow: "0 12px 40px rgba(0,0,0,0.4)",
                  }}
                />
              </>
            )}
          </Box>
        </Modal>
      </Container>
    </section>
  );
};

export default LocationSection;
